module.exports = __webpack_public_path__ + "static/media/map.c1f3d442.png";